import React from 'react';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';

import inject from '../../../../../hoc/injectHoc';
import MediaStickPricingTabs from '../../../../../common/pricingTabs/MediaStickPricingTabs';
import {PAYMENT_PLAN_MONTHLY} from '../../../../../../constants/subscriptionPlanConstants';

/**
 * The MediaStickStep component.
 */
class MediaStickStep extends React.Component {
  /**
   * Purchase media sticks
   *
   * @param {'monthly' | 'lifetime'} frequency
   * @param {number} quantity
   */
  onPurchaseMediaSticks = (frequency, quantity) => {
    const {purchaseFlowStore, nextStep} = this.props;

    purchaseFlowStore.setMediaStickPlan({
      frequency,
      quantity,
    });

    if (nextStep) {
      nextStep();
    }
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {purchaseFlowStore} = this.props;
    const {mediaStickPlan} = purchaseFlowStore;

    let tabSelected;
    if (mediaStickPlan) {
      tabSelected = mediaStickPlan.frequency === PAYMENT_PLAN_MONTHLY ? 'subscription' : 'lifetime';
    }

    return (
      <MediaStickPricingTabs
        onPurchase={this.onPurchaseMediaSticks}
        user={purchaseFlowStore.currentUser}
        startingCreditCount={mediaStickPlan ? mediaStickPlan.quantity : undefined}
        tabSelected={tabSelected}
      />
    );
  }
}

MediaStickStep.propTypes = {
  nextStep: PropTypes.func,
  purchaseFlowStore: MobxPropTypes.observableObject,
};

MediaStickStep.wrappedComponent = {};
MediaStickStep.wrappedComponent.propTypes = {
  purchaseFlowStore: MobxPropTypes.observableObject.isRequired,
};

export default inject(MediaStickStep)(
  observer(MediaStickStep)
);
